<template>
  <div class="dashboard-layout" :class="{ 'sidebar-open': isSidebarOpen }">
    <aside v-if="!hideAside || !isLgUp" class="sidebar">
      <!-- =====================================================
           LOGO / CABECERA - FIJO
      ====================================================== -->
      <div class="brand">
        <router-link
          :to="{ name: 'reservas' }"
          class="logo-link"
          title="Ir a Reservas"
        >
          <img
            src="@/assets/img/logo.png"
            class="logo-nav mx-auto"
            alt="SportsFlow"
          />
        </router-link>
        <button
          class="btn btn-link text-white d-lg-none ms-auto"
          @click="toggleSidebar"
          aria-label="Cerrar menú"
        >
          <span class="material-symbols-rounded">close</span>
        </button>
      </div>

      <!-- =====================================================
           MENÚ SUPERIOR - FIJO
           Deportes / Reservas
      ====================================================== -->
      <nav class="nav flex-column primary-nav">
        <div v-for="item in topLevel" :key="item.name" class="nav-item">
          <!-- Ruta sin hijos -->
          <RouterLink
            v-if="!hasChildren(item) && item.nav"
            :to="{ name: item.name }"
            class="nav-link d-flex align-items-center gap-2"
            active-class="router-link-exact-active"
          >
            <WhatsAppIcon v-if="item.icon === 'whatsapp'" class="icon" />

            <span v-else-if="item.icon" class="material-symbols-rounded icon">
              {{ item.icon }}
            </span>

            <span class="label">
              {{ item?.display || item.name }}
            </span>
          </RouterLink>

          <!-- Ruta con hijos -->
          <div v-else-if="hasChildren(item) && item.nav" class="dropdown-wrap">
            <button
              type="button"
              class="nav-link w-100 d-flex align-items-center gap-2 justify-content-between dropdown-toggle-btn"
              @click="toggleOpen(item.name)"
            >
              <span class="d-flex align-items-center gap-2">
                <WhatsAppIcon v-if="item?.icon === 'whatsapp'" class="icon" />

                <span
                  v-else-if="item?.icon"
                  class="material-symbols-rounded icon"
                >
                  {{ item.icon }}
                </span>

                <span class="label">
                  {{ item?.display || item.name }}
                </span>
              </span>

              <span
                class="material-symbols-rounded caret"
                :class="{ open: isOpen(item.name) }"
              >
                expand_more
              </span>
            </button>

            <div class="submenu" v-show="isOpen(item.name)">
              <RouterLink
                v-for="child in item.children"
                :key="child.name || child.path"
                :to="
                  child.name
                    ? { name: child.name }
                    : resolveChildPath(item, child)
                "
                class="nav-link sublink d-flex align-items-center gap-2"
                active-class="router-link-exact-active"
              >
                <WhatsAppIcon v-if="child?.icon === 'whatsapp'" class="icon" />

                <span
                  v-else-if="child?.icon"
                  class="material-symbols-rounded icon"
                >
                  {{ child.icon }}
                </span>

                <span class="label">
                  {{ child?.label || child.name || child.path }}
                </span>
              </RouterLink>
            </div>
          </div>
        </div>
      </nav>

      <!-- =====================================================
           MENÚ CENTRAL - ÚNICA ZONA CON SCROLL
           Estadísticas → Mejoras
      ====================================================== -->
      <div class="sidebar-scroll">
        <nav v-if="bottomLevel.length" class="nav flex-column bottom-nav">
          <div v-for="item in bottomLevel" :key="item.name" class="nav-item">
            <!-- Ruta sin hijos -->
            <RouterLink
              v-if="!hasChildren(item)"
              :to="{ name: item.name }"
              class="nav-link d-flex align-items-center gap-2"
              active-class="router-link-exact-active"
            >
              <WhatsAppIcon v-if="item.icon === 'whatsapp'" class="icon" />

              <span v-else-if="item.icon" class="material-symbols-rounded icon">
                {{ item.icon }}
              </span>

              <span class="label">
                {{ item?.display || item.name }}
              </span>
            </RouterLink>

            <!-- Ruta con hijos -->
            <div v-else class="dropdown-wrap">
              <button
                type="button"
                class="nav-link w-100 d-flex align-items-center gap-2 justify-content-between dropdown-toggle-btn"
                @click="toggleOpen(item.name)"
              >
                <span class="d-flex align-items-center gap-2">
                  <WhatsAppIcon v-if="item?.icon === 'whatsapp'" class="icon" />

                  <span
                    v-else-if="item?.icon"
                    class="material-symbols-rounded icon"
                  >
                    {{ item.icon }}
                  </span>

                  <span class="label">
                    {{ item?.display || item.name }}
                  </span>
                </span>

                <span
                  class="material-symbols-rounded caret"
                  :class="{ open: isOpen(item.name) }"
                >
                  expand_more
                </span>
              </button>

              <div class="submenu" v-show="isOpen(item.name)">
                <RouterLink
                  v-for="child in item.children"
                  :key="child.name || child.path"
                  :to="
                    child.name
                      ? { name: child.name }
                      : resolveChildPath(item, child)
                  "
                  class="nav-link sublink d-flex align-items-center gap-2"
                  active-class="router-link-exact-active"
                >
                  <WhatsAppIcon
                    v-if="child?.icon === 'whatsapp'"
                    class="icon"
                  />

                  <span
                    v-else-if="child?.icon"
                    class="material-symbols-rounded icon"
                  >
                    {{ child.icon }}
                  </span>

                  <span class="label">
                    {{ child?.label || child.name || child.path }}
                  </span>
                </RouterLink>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <!-- =====================================================
           USUARIO - FIJO ABAJO
      ====================================================== -->
      <div id="nav_bottom" class="nav flex-column">
        <div class="usuario_seccion dropdown-wrap dropup">
          <button
            type="button"
            class="nav-link w-100 d-flex align-items-center gap-2 justify-content-between dropdown-toggle-btn"
            @click="toggleOpen('usuario')"
          >
            <span class="d-flex align-items-center gap-2">
              <span class="material-symbols-rounded icon"> person </span>

              <span class="label">
                {{ userName }}
              </span>
            </span>

            <span
              class="material-symbols-rounded caret"
              :class="{ open: isOpen('usuario') }"
            >
              expand_more
            </span>
          </button>

          <div class="submenu" v-show="isOpen('usuario')">
            <RouterLink
              to="mi-perfil"
              class="nav-link sublink d-flex align-items-center gap-2"
              active-class="router-link-exact-active"
            >
              <span class="material-symbols-rounded icon">
                manage_accounts
              </span>

              <span class="label"> Mi Perfil </span>
            </RouterLink>

            <div
              id="logout"
              @click.prevent="logout"
              class="nav-link sublink d-flex align-items-center gap-2"
            >
              <span class="material-symbols-rounded icon"> logout </span>

              <span class="label"> Cerrar Sesión </span>
            </div>
          </div>
        </div>
      </div>

      <!-- =====================================================
           VERSIÓN - FIJO ABAJO
      ====================================================== -->
      <div class="version-sistema text-sm-end">
        <span> Versión {{ versionSistema }} </span>
      </div>
    </aside>

    <!-- Backdrop mobile -->
    <div
      v-if="isSidebarOpen && !isLgUp"
      class="backdrop"
      @click="toggleSidebar"
    ></div>

    <!-- =====================================================
         MAIN
    ====================================================== -->
    <div class="main-area">
      <header class="header d-lg-none" :class="{ 'is-scrolled': scrolled }">
        <button
          class="btn btn-link d-lg-none p-0 me-2"
          @click="toggleSidebar"
          aria-label="Abrir menú"
        >
          <span class="material-symbols-rounded text-white"> menu </span>
        </button>

        <RouterLink :to="{ name: 'deportes' }" class="ms-auto">
          <img src="@/assets/img/logo.png" alt="Logo" class="logo-nav-mobile" />
        </RouterLink>
      </header>

      <main class="content">
        <slot v-if="hasSlot"></slot>
        <RouterView v-else />
      </main>
    </div>
  </div>
</template>

<script setup>
import WhatsAppIcon from "@/components/WhatsAppIcon.vue";

import { ref, computed, useSlots, onBeforeUnmount, onMounted } from "vue";

import { useRoute, useRouter } from "vue-router";
import { appRoutes as baseRoutes } from "@/router";
import { apiGetParametroGeneralPorClave } from "@/api";
import { getUser } from "@/utils/auth";

const props = defineProps({
  routes: {
    type: Array,
    default: () => baseRoutes,
  },
});

const route = useRoute();
const router = useRouter();

const hideAside = computed(() => route.matched.some((r) => r.meta?.hideAside));

const versionSistema = ref("");

const userName = getUser().usuario;
const id_rol = getUser().rol;

/* ============================================================
   RESPONSIVE
============================================================ */

const mq = window.matchMedia("(min-width: 992px)");
const isLgUp = ref(mq.matches);

const onMQ = (e) => {
  isLgUp.value = e.matches;
};

mq.addEventListener?.("change", onMQ);

onBeforeUnmount(() => {
  mq.removeEventListener?.("change", onMQ);
});

/* ============================================================
   SIDEBAR MOBILE
============================================================ */

const isSidebarOpen = ref(false);

const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};

router.afterEach(() => {
  if (!isLgUp.value) {
    isSidebarOpen.value = false;
  }
});

/* ============================================================
   HEADER MOBILE
============================================================ */

const scrolled = ref(false);

const onScroll = () => {
  scrolled.value = window.scrollY > 0;
};

/* ============================================================
   VERSIÓN
============================================================ */

async function obtenerVersion() {
  const resp = await apiGetParametroGeneralPorClave("version_sistema");

  versionSistema.value =
    resp?.valor ?? resp?.valor_caracter ?? resp?.valor_numerico ?? "";
}

onMounted(async () => {
  await obtenerVersion();

  window.addEventListener("scroll", onScroll, {
    passive: true,
  });

  onScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
});

/* ============================================================
   SLOT
============================================================ */

const slots = useSlots();

const hasSlot = computed(() => !!slots.default);

/* ============================================================
   DROPDOWNS
============================================================ */

const openSet = ref(new Set());

const isOpen = (name) => {
  return openSet.value.has(name);
};

const toggleOpen = (name) => {
  const next = new Set(openSet.value);

  if (next.has(name)) {
    next.delete(name);
  } else {
    next.add(name);
  }

  openSet.value = next;
};

/* ============================================================
   RUTAS
============================================================ */

const hasChildren = (item) =>
  Array.isArray(item.children) && item.children.length > 0;

const visibleRoutes = computed(() =>
  props.routes.filter((r) => r.nav !== false && r.nivel_rol >= id_rol),
);

/*
 * Menú superior fijo.
 * Todo lo que NO sea nivel_rol 2.
 */
const topLevel = computed(() =>
  visibleRoutes.value.filter((r) => r.nivel_rol !== 2),
);

/*
 * Menú central scrolleable.
 * nivel_rol 2 para administrador.
 */
const bottomLevel = computed(() =>
  visibleRoutes.value.filter((r) => r.nivel_rol === 2 && id_rol === 2),
);

const resolveChildPath = (parent, child) => {
  const base = parent.path?.replace(/\/$/, "") || "";

  const c = (child.path || "").replace(/^\//, "");

  return child.path?.startsWith("/") ? child.path : `${base}/${c}`;
};

/* ============================================================
   LOGOUT
============================================================ */

const logout = () => {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("ac_token");

  window.location.href = "/";
};
</script>

<style scoped>
/* ============================================================
   LAYOUT GENERAL
============================================================ */

.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
}

/* ============================================================
   SIDEBAR
============================================================ */

.sidebar {
  width: var(--sidebar-width);
  min-width: 200px;
  max-width: 360px;

  background: #1e293b;
  color: #fff;

  display: flex;
  flex-direction: column;

  height: 100vh;
  height: 100dvh;

  padding: 1rem;

  /*
   * MUY IMPORTANTE:
   * el sidebar completo NO scrollea.
   */
  overflow: hidden;

  resize: horizontal;

  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.04) inset;
}

/* ============================================================
   LOGO / BRAND
============================================================ */

.brand {
  flex: 0 0 auto;

  display: flex;
  align-items: center;

  gap: 0.5rem;
  margin-bottom: 1rem;
}

.logo-nav {
  width: 36%;
}

/* ============================================================
   MENÚ SUPERIOR FIJO
============================================================ */

.primary-nav {
  flex: 0 0 auto;
}

.primary-nav .nav-item {
  margin-bottom: 0.25rem;
}

/* ============================================================
   ZONA SCROLLEABLE
============================================================ */

.sidebar-scroll {
  /*
   * Ocupa todo el espacio libre entre:
   * - menú superior
   * - usuario inferior
   */
  flex: 1 1 auto;

  /*
   * Fundamental para que un hijo flex pueda
   * realmente reducirse y generar scroll.
   */
  min-height: 0;

  overflow-y: auto;
  overflow-x: hidden;

  margin-top: 0.75rem;
  padding-top: 0.75rem;
  padding-right: 0.25rem;

  border-top: 1px solid rgba(255, 255, 255, 0.08);

  scrollbar-width: thin;
}

/* Chrome / Edge */
.sidebar-scroll::-webkit-scrollbar {
  width: 5px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);

  border-radius: 999px;
}

.sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}

.bottom-nav {
  margin: 0;
  padding: 0 0.25rem 0.5rem 0;

  border-top: 0;
}

/* ============================================================
   LINKS
============================================================ */

nav {
  padding-right: 0;
}

.nav-link {
  color: #fff;
  text-decoration: none;

  font-weight: 500;

  display: flex;
  align-items: center;

  gap: 0.5rem;

  padding: 0.5rem 0.75rem;

  border-radius: 0.5rem;

  transition: background 0.15s;
}

.nav-link:hover,
.nav-link.router-link-exact-active {
  background: #334155;
  color: var(--brand-green-300);
}

/* ============================================================
   DROPDOWN
============================================================ */

.dropdown-wrap {
  display: flex;
  flex-direction: column;
}

.dropdown-toggle-btn {
  appearance: none;

  background: transparent;
  border: 0;

  color: inherit;
  text-align: left;

  padding: 0.5rem 0.75rem;

  border-radius: 0.5rem;

  width: 100%;
}

.caret {
  transition: transform 0.15s ease;
}

.caret.open {
  transform: rotate(180deg);
}

.submenu {
  padding-left: 0.5rem;
}

.sublink {
  opacity: 0.9;
  padding-left: 2rem;
}

.icon {
  font-size: 1.3em;
  line-height: 1;
}

/* ============================================================
   USUARIO FIJO ABAJO
============================================================ */

#nav_bottom {
  flex: 0 0 auto;

  margin-top: 0;
  padding-top: 0.5rem;
}

.usuario_seccion {
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  padding-top: 0.5rem;
}

.dropup .submenu {
  order: -1;
  margin-bottom: 0.25rem;
}

#logout {
  cursor: pointer;
}

/* ============================================================
   VERSIÓN
============================================================ */

.version-sistema {
  flex: 0 0 auto;

  color: #8080807d;

  font-size: 0.6rem;

  padding-top: 0.25rem;
}

/* ============================================================
   MAIN
============================================================ */

.main-area {
  flex: 1;

  display: flex;
  flex-direction: column;

  min-width: 0;
}

.content {
  flex: 1;

  min-width: 0;
  max-width: 100%;

  overflow-x: hidden;

  padding: 1.25rem;
}

/* ============================================================
   HEADER MOBILE
============================================================ */

.header {
  position: sticky;
  top: 0;

  z-index: 1020;

  height: var(--header-h);

  background: #1e293b;

  padding: 0 1rem;

  display: flex;
  align-items: center;

  border-bottom: 1px solid #e5e7eb;
}

.header.is-scrolled {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.07);
}

.logo-nav-mobile {
  max-height: calc(var(--header-h) - 12px) !important;

  width: auto;

  object-fit: contain;

  display: block;

  flex-shrink: 0;

  max-width: 100%;
}

/* ============================================================
   MOBILE / TABLET
============================================================ */

@media (max-width: 991.98px) {
  .sidebar {
    position: fixed;

    inset: 0 auto 0 0;

    transform: translateX(-100%);

    transition: transform 0.2s ease;

    z-index: 1040;

    max-width: 80vw;

    resize: none;
  }

  .dashboard-layout.sidebar-open .sidebar {
    transform: translateX(0);
  }

  .dashboard-layout.sidebar-open::after {
    content: "";

    position: fixed;

    inset: 0;

    background: rgba(0, 0, 0, 0.35);

    z-index: 1030;
  }

  .sidebar .brand .logo-nav {
    display: none;
  }

  .sidebar .brand {
    justify-content: flex-end;
    margin-bottom: 0.5rem;
  }
}
</style>
